/**
 * OWA-specific login hint claim cache implementation.
 *
 * Storage Strategy:
 * - Memory cache: Keyed by mailboxInfo indexer for consistency
 * - Local storage: Account-scoped key (`login_hint_claim_${indexer}`)
 *
 * The claim is populated from MSAL account's idTokenClaims.login_hint
 * and used in subsequent token requests to ensure correct account identity.
 */

import { createLoginHintCache } from 'owa-auth-callbacks';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Lazy initialization to avoid module-scope side effects.
 */
let cacheInstance: ReturnType<typeof createLoginHintCache> | undefined;

function getCache() {
    if (!cacheInstance) {
        cacheInstance = createLoginHintCache();
    }
    return cacheInstance;
}

export function getLoginHintClaim(mailboxInfo: MailboxInfo): string | undefined {
    return getCache().getLoginHintClaim(mailboxInfo);
}

export function setLoginHintClaim(mailboxInfo: MailboxInfo, loginHintClaim: string): void {
    getCache().setLoginHintClaim(mailboxInfo, loginHintClaim);
}

export function deleteLoginHintClaim(mailboxInfo: MailboxInfo): void {
    getCache().deleteLoginHintClaim(mailboxInfo);
}
